export default __webpack_public_path__ + "static/media/Shendoh of the Eternal Blaze.841f2d81.jpg";